var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.visible,
      expression: "visible"
    }]
  }, [_c('div', {
    staticClass: "popup_wrap file_upload"
  }, [_c('div', {
    staticClass: "popup_title"
  }, [_vm._m(0), _c('a', {
    staticClass: "_command[CmmComm.closeLayer]"
  }, [_c('div', {
    staticClass: "btn_close",
    attrs: {
      "id": "popup_close",
      "title": "Close"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._m(1)])])]), _c('div', {
    staticClass: "popup_content1"
  }, [_vm.getExperimentResultMode != 'readOnly' ? _c('div', {
    staticClass: "file-drop-zone"
  }, [_c('div', {
    staticClass: "file-drop-zone-btn-upload"
  }, [_c('input', {
    ref: "fileInput",
    staticClass: "input-file-upload",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "id": "atch_file_id",
      "name": "atch_file_id",
      "multiple": ""
    },
    on: {
      "change": function ($event) {
        return _vm.addFile($event, 'file');
      }
    }
  }), _c('label', {
    staticClass: "btn_basic2 btn_type1 ce-file-upload",
    on: {
      "click": _vm.triggerFileInput
    }
  }, [_vm._v("파일 업로드")])]), _c('div', {
    staticClass: "text_center"
  }, [_vm._v(" 10GB 이상 파일은 업로드가 불가능합니다."), _c('br'), _vm._v(" 등록 가능한 파일은 다음과 같습니다."), _c('br'), _c('span', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold"
    }
  }, [_vm._v("[ " + _vm._s(_vm.availableExtension.size == 0 ? '전체허용' : Array.from(_vm.availableExtension).join(', ')) + " ]")]), _c('br'), _vm._v(" 추가 확장자 요청의 경우 관리자에게 문의해주세요. ")])]) : _vm._e(), _c('br'), _c('br'), _c('table', {
    staticClass: "board_view_area goods_img",
    attrs: {
      "width": "100%",
      "border": "0",
      "cellspacing": "0",
      "cellpadding": "0",
      "id": "t_file"
    }
  }, [_vm._m(2), _vm._m(3), _c('tbody', _vm._l(_vm.fileArray.filter(function (file) {
    return file.active;
  }), function (file, index) {
    return _c('tr', {
      key: file.fileId
    }, [_c('td', [_c('span', {
      staticClass: "file_item",
      staticStyle: {
        "display": "inline-block"
      },
      on: {
        "click": function ($event) {
          return _vm.downloadFile(file.fileId, file.originalFileName);
        }
      }
    }, [_vm._v(" " + _vm._s(file.originalFileName.length > 25 ? file.originalFileName.slice(0, 25) + "..." : file.originalFileName) + " ")]), _c('br'), file.mimeType == 'video/mp4' ? _c('video', {
      staticStyle: {
        "max-width": "100%",
        "height": "auto"
      },
      attrs: {
        "id": "videoPlayer",
        "controls": "",
        "preload": "metadata"
      }
    }, [_c('source', {
      attrs: {
        "src": file.url,
        "type": "video/mp4"
      }
    }), _vm._v(" 브라우저가 영상을 지원하지 않습니다. ")]) : _vm._e()]), _c('td', {
      staticStyle: {
        "vertical-align": "middle"
      }
    }, [_vm._v(" " + _vm._s(_vm.formatSize(file.size)) + " ")]), _c('td', {
      staticStyle: {
        "vertical-align": "middle"
      }
    }, [_vm.getExperimentResultMode != 'readOnly' ? _c('a', {
      staticClass: "btn_node_delete",
      on: {
        "click": function ($event) {
          return _vm.deleteFileMapping(file.fileId);
        }
      }
    }, [_vm._v(" ")]) : _vm._e()])]);
  }), 0)])]), _c('div', {
    staticClass: "popup_footer"
  }, [_vm.getExperimentResultMode != 'readOnly' ? _c('a', {
    staticClass: "btn_type1",
    on: {
      "click": _vm.saveMapping
    }
  }, [_vm._v("저장")]) : _vm._e(), _c('a', {
    staticClass: "btn_type3",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("닫기")])])]), _c('div', {
    staticClass: "mask_wrap",
    staticStyle: {
      "display": "block"
    }
  }), _c('Loading', {
    attrs: {
      "visible": _vm.loading,
      "type": "fixed"
    }
  }), _vm.uploadProgress > 0 && _vm.uploadProgress < 100 ? _c('div', {
    staticClass: "progress-overlay"
  }, [_c('div', {
    staticClass: "progress-container"
  }, [_c('div', {
    staticClass: "progress-bar"
  }, [_c('div', {
    staticClass: "progress-fill",
    style: {
      width: _vm.uploadProgress + '%'
    }
  })]), _c('div', {
    staticClass: "progress-text"
  }, [_vm._v(_vm._s(_vm.uploadProgress) + "% 업로드 중...")])])]) : _vm._e()], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', [_c('span', {
    attrs: {
      "id": "node_title"
    }
  }, [_vm._v("첨부파일")])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "btn_close_box"
  }, [_c('span'), _c('span')]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('colgroup', [_c('col', {
    attrs: {
      "width": "70%"
    }
  }), _c('col', {
    attrs: {
      "width": "20%"
    }
  }), _c('col', {
    attrs: {
      "width": "10%"
    }
  })]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('thead', [_c('tr', [_c('th', [_vm._v("파일명")]), _c('th', [_vm._v("크기")]), _c('th', [_vm._v("삭제")])])]);

}]

export { render, staticRenderFns }